import React, { useMemo } from 'react';
import { styled } from '@linaria/react';
import { getOfferContextFromRoomContext } from 'middleware/analytics/contexts/roomContext';
import { Text } from '@daedalus/atlas/Text';
import { AnalyticsContext, RoomContext } from '@daedalus/core/src/analytics/types/Events';
import { BoardType } from '@daedalus/core/src/api-types/bovio/response/booking';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { getHasFreeCancellation } from '@daedalus/core/src/offer/business/cancellationPenalties';
import { getRoomOfferBoardType } from '@daedalus/core/src/offer/business/meal';
import { Offer } from '@daedalus/core/src/offer/types/offer';
import { Room } from '@daedalus/core/src/room/types/room';
import { MealName } from '@daedalus/shared/src/booking/Meal';
import { useHandlePriceDetailsClick } from '../RoomOffer/useHandlePriceDetailsClick';
import { RoomOfferCTA } from '../RoomOfferCTA';
import { RoomOfferPrice } from '../RoomOfferPrice/RoomOfferPrice';
type Props = {
  hotelId: string;
  room: Room;
  offer: Offer;
  component: string;
  roomContext: RoomContext;
};
const OfferLayout = /*#__PURE__*/styled('div')({
  name: "OfferLayout",
  class: "o1uvyvda",
  propsAsIs: false
});
const SpacedListItem: React.FC<{
  hasSpacer: boolean;
}> = ({
  children,
  hasSpacer
}) => {
  return <>
      {children}
      {hasSpacer && ' · '}
    </>;
};
const CompactRoomOfferDetails = ({
  offer
}: {
  offer: Offer;
}) => {
  if (!offer) return null;
  const boardType = getRoomOfferBoardType(offer.services);
  const hasMeal = boardType !== BoardType.RoomOnly;
  const isFreeCancellation = getHasFreeCancellation(offer.cancellationPenalties);
  const {
    canPayLater
  } = offer;
  const perks = [...(hasMeal ? [<MealName key={0} boardType={boardType} />] : []), ...(canPayLater ? [<FormattedMessageWrapper key={1} id="rate.payAtProperty" defaultMessage="Pay at property" />] : []), ...(isFreeCancellation ? [<FormattedMessageWrapper key={2} id="refundable" defaultMessage="Free cancellation" />] : [])];
  return <Text variant="bodyXS" colorPath="content.featured.c500">
      {perks.map((perk, index) => <SpacedListItem key={index} hasSpacer={index < perks.length - 1}>
          {perk}
        </SpacedListItem>)}
    </Text>;
};
export const CompactRoomOffer = ({
  hotelId,
  room,
  offer,
  component,
  roomContext
}: Props) => {
  const offerContext = getOfferContextFromRoomContext(roomContext, offer.id);
  const analyticsContext = useMemo(() => {
    if (!(roomContext && offer)) return null;
    return {
      [AnalyticsContext.RoomContext]: roomContext,
      [AnalyticsContext.OfferContext]: offerContext
    };
  }, [offer.id, roomContext]);
  const handlePriceDetailsClick = useHandlePriceDetailsClick({
    hotelId,
    room,
    offer,
    component,
    analyticsContext
  });
  return <OfferLayout>
      <div>
        <RoomOfferPrice hotelId={hotelId} offer={offer} onClickPriceDetails={handlePriceDetailsClick} isCompact />
        <CompactRoomOfferDetails offer={offer} />
      </div>
      <RoomOfferCTA hotelId={hotelId} room={room} offer={offer} component={component} roomContext={roomContext} offerContext={offerContext} />
    </OfferLayout>;
};

require("./CompactRoomOffer.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CompactRoomOffer.tsx");